<template>
  <div>
    <v-card class="card-box" elevation="0">
      <v-card-text class="pa-0">
        <v-sheet
          elevation="0"
          class="cnt-wrap wide py-5 px-7 ml-auto d-flex justify-space-between"
        >
          <span class="label">
            <v-icon class="mr-1" size="18" color="#505961"
              >mdi-clipboard-account-outline</v-icon
            >근무시간
          </span>
          <span
            ><span class="point-blue cnt">{{ totHour }}</span
            ><span class="unit">시간</span>
          </span>
        </v-sheet>
        <v-row class="mt-5 mb-0 cnt-wrap no-bg">
          <v-col cols="6" class="pa-0 text-center">
            <div class="label">
              <v-icon class="mr-1" color="#777e87" size="18">mdi-alarm</v-icon
              >기본
            </div>
            <div class="mt-desc">
              <span class="cnt">{{ workHour }}</span
              ><span class="unit">시간</span>
            </div>
          </v-col>
          <v-col cols="6" class="pa-0 text-center divider">
            <div class="label">
              <v-icon class="mr-1" color="#777e87" size="18"
                >mdi-weather-night</v-icon
              >연장
            </div>
            <div class="mt-desc">
              <span class="point-red cnt">{{ otHour }}</span>
              <span class="unit">시간</span>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
/* 근무현황 카드 컴포넌트 */
import { getWorkStaTimeInfo } from '@/api/workStatus';

export default {
  props: {
    searchParam: {
      type: Object,
    },
  },

  data: () => ({
    totHour: '-',
    workHour: '-',
    otHour: '-',
  }),

  watch: {
    searchParam() {
      this.fetchWorkStaTimeInfo();
    },
  },

  methods: {
    /* 근무현황시간정보조회 */
    async fetchWorkStaTimeInfo() {
      try {
        const response = await getWorkStaTimeInfo({
          searchGubun: 'w',
          searchSdate: this.searchParam.searchTerm.sdate,
          searchEdate: this.searchParam.searchTerm.edate,
        });
        const dataObj = response.data.data;

        this.totHour = dataObj.totHour;
        this.workHour = dataObj.workHour;
        this.otHour = dataObj.otHour;
        return response;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style></style>
